import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import defaultTheme from '../../config/theme';

import Decorate from './Decorate';
import DebugService from '../../../services/DebugService';

import '../../styles.css';

BLink.propTypes = {
  title: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,  // necessaire pour styled
  variant: PropTypes.string, // surcharges de styles
};

function BLink({title,target,onClick,className,variant}){

  if (title === undefined) {
    return null;
  }
  if (target === undefined && onClick === undefined) {
    return null;
  }

  // cas onClick
  if (onClick !== undefined) {

    const handleClick = () => {
      if (DebugService.getInstance().enabled) console.log('Link - Click with onClick');
      onClick();
    };

    return (
      <div className={className + ' bostik-link' + (undefined !== variant && variant === 'reset' ? ' bostik-reset' : '')} onClick={() => handleClick()}>
        <Decorate label={title} />
      </div>
    );
  }

  // cas target (lien)
  return (
    <a className={className + ' bostik-link' + (undefined !== variant && variant === 'reset' ? ' bostik-reset' : '')} href={target} target="_blank" rel="noreferrer">
      <Decorate label={title} />
    </a>
  );
}

const Link = styled(BLink)`
  text-decoration: underline;
  text-transform: uppercase;
  cursor: pointer;
  font-weight: bold;
  font-size: ${props => {
    if(undefined !== props.variant && props.variant === 'reset' || props.variant === 'resetsession'){
      return '0.8em';
    }
    return '1em'}
  };
  color: ${({variant,theme}) => (undefined !== variant && variant === 'reset' ? theme.resetFontColor : 'inherit')};
  &:hover {
    text-decoration: none;
    cursor: pointer;
  }
`;
Link.defaultProps = {
  variant: '',
  theme: defaultTheme
};

export default Link;
